import type { LineItem as SwLineItem } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import type { HblLineItem } from '@/utils/types'
import { hblMapMedia, hblMediaIncludes, hblMapPrice, hblPriceIncludes } from '#imports'

export const hblLineItemIncludes = {
    'cart_line_item': [
        'id',
        'referencedId',
        'payload',
        'label',
        'quantity',
        'quantityInformation',
        'type',
        'cover',
        'price',
        'children',
    ],
    ...hblMediaIncludes,
    ...hblPriceIncludes,
}

export function hblMapLineItem (lineItem: SwLineItem): HblLineItem {
    return {
        id: lineItem.id,
        // @ts-ignore
        itemId: lineItem.payload?.productId ? lineItem.payload?.productId : lineItem.referencedId,
        // @ts-ignore
        sku: lineItem.payload?.productNumber,
        // @ts-ignore
        seoUrl: lineItem.payload?.seoUrl,
        // @ts-ignore
        name: lineItem.label,
        // @ts-ignore
        quantity: lineItem.quantity,
        // @ts-ignore
        stock: lineItem.payload?.stock,
        // @ts-ignore
        max: lineItem.quantityInformation?.maxPurchase,
        // @ts-ignore
        options: lineItem.payload?.options,
        // @ts-ignore
        purchaseUnit: lineItem.payload?.purchaseUnit,
        // @ts-ignore
        deliveryTimeCustomFields: lineItem.payload?.deliveryTimeCustomFields,
        // @ts-ignore
        isCloseout: lineItem.payload?.isCloseout,
        type: lineItem.type,
        // @ts-ignore
        promotions: lineItem.payload?.promotions,
        // @ts-ignore
        promotionType: lineItem.payload?.line_item_type,
        // @ts-ignore
        promotionName: lineItem.payload?.promotion_name,
        // @ts-ignore
        giftPrice: lineItem.payload?.meteorFreeGiftOriginalPrice,
        // @ts-ignore
        media: hblMapMedia(lineItem.cover),
        // @ts-ignore
        price: hblMapPrice(lineItem.price),
        // @ts-ignore
        children: hblMapLineItems(lineItem.children),
        // @ts-ignore
        isGreetingCard: lineItem.payload?.repertusIsGreetingCard,
        // @ts-ignore
        greetingCardText: lineItem.payload?.repertusGreetingCardText,
        // @ts-ignore
        packUnit: lineItem?.payload?.packUnit,
        // @ts-ignore
        payload: lineItem.payload
    }
}
